// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"1d75be2a","156":"15ddbe54","409":"5d8cb543","957":"72be29b9"}[chunkId] + ".chunk.js";
};